import moment from "moment";
import { formatDate } from "react-lib/utils/dateUtils";
import { HeaderLogoWithAddress } from "react-lib/apps/HISV3/common/HeaderPdfFormTemplate";

const FORM_NAME = "FormORCaseList";

const FormORCaseList = async (props: any) => {
  const headerForm = await HeaderLogoWithAddress({
    pageMargins: [15, 140, 0, 50],
    font: "THSarabunNew",
    form: FORM_NAME,
    logoHeight: 38,
    styles: {
      title: {
        bold: true,
        fontSize: 20,
        alignment: "center",
      },
      header: {
        fontSize: 18,
        alignment: "center",
      },
      tableHeader: {
        fontSize: 16,
        alignment: "center",
      },
      tableDetail: {
        fontSize: 14,
      },
      addressRightStyle: {
        fontSize: 12,
        alignment: "right",
      },
      addressLeftStyle: {
        fontSize: 12,
        alignment: "left",
      },
    },
    titleContent: [
      {
        text: "รายงานการใช้ห้องผ่าตัด",
        style: "title",
      },
      {
        text: `วันที่ ${props?.start_date} - ${props?.end_date}`,
        style: "header",
      },
    ],
  });
  const { font, images, styles } = headerForm;

  return {
    defaultStyle: {
      font: font,
      lineHeight: 1,
      fontSize: 12,
    },
    pageSize: "A4",
    pageOrientation: "landscape",
    ...styles,
    ...headerForm,
    content: [
      {
        margin: [20, 0, 10, 10],
        table: {
          widths: ["7%", "6%", "15%", "3%", "5%", "15%", "15%", "*", "8%"],
          body: [
            [
              { text: "วันที่ผ่าตัด", style: "tableHeader", bold: true },
              { text: "HN", style: "tableHeader", bold: true },
              { text: "ชื่อ - สกุล", style: "tableHeader", bold: true },
              { text: "อายุ", style: "tableHeader", bold: true },
              { text: "Cases", style: "tableHeader", bold: true },
              { text: "Location/Room", style: "tableHeader", bold: true },
              { text: "แพทย์ผ่าตัด", style: "tableHeader", bold: true },
              { text: "Operation", style: "tableHeader", bold: true },
              { text: "Anesthesia", style: "tableHeader", bold: true },
            ],
            ...(props?.data || []).map((item: any, index: number) => [
              {
                text: item.start_date,
                style: "tableDetail",
                alignment: "center",
              },
              { text: item.hn, style: "tableDetail", alignment: "center" },
              { text: item.patient_name, style: "tableDetail" },
              {
                text: item.patient_age,
                style: "tableDetail",
                alignment: "center",
              },
              {
                text: item.caseText,
                style: "tableDetail",
                alignment: "center",
              },
              {
                text: item.locationRoom,
                style: "tableDetail",
                alignment: "center",
              },
              { text: item.primary_doctor_name, style: "tableDetail" },
              { text: item.pre_operation_summary, fontSize: 14 },
              {
                text: item.anesthesia_method_name,
                style: "tableDetail",
                alignment: "center",
              },
            ]),
          ],
        },
      },
    ],
    footer: function (currentPage: number, pageCount: number) {
      const printDateMM = moment();
      return {
        stack: [
          {
            margin: [40, 0, 20, 0],
            columns: [
              {
                width: "50%",
                stack: [
                  {
                    text: `วันเวลาที่พิมพ์ : ${formatDate(printDateMM)} [${printDateMM.format(
                      "HH:mm"
                    )}]`,
                    style: "addressLeftStyle",
                  },
                  {
                    text: `ผู้ออกรายงาน : ${props?.print_user || ""}`,
                    style: "addressLeftStyle",
                  },
                ],
              },
              {
                width: "50%",
                stack: [
                  {
                    text: `หน้าที่ ${currentPage} / ${pageCount}`,
                    style: "addressRightStyle",
                  },
                ],
              },
            ],
          },
        ],
      };
    },
    images: {
      ...images,
    },
  };
};

export default FormORCaseList;
